// Ephemeral, non-reactive flag: set when the user navigates to a collection
// by clicking it in the Pinned list, so CollectionsList knows to scroll the
// (otherwise off-screen) matching item into view. Not part of Redux state
// since it's consumed once, synchronously, right after navigation.
let cameFromPinned = false;

export function markPinnedNavigation() {
  cameFromPinned = true;
}

export function consumePinnedNavigation(): boolean {
  const value = cameFromPinned;
  cameFromPinned = false;
  return value;
}
